import { updateFieldState } from '@gef-ui/redux-common/actions/fieldState';
import { globalErrors } from '@gef-ui/redux-common/constants';
import { getGlobalErrors } from '@gef-ui/redux-common/selectors/globalErrors';
import { getRegisteredFields, getRegisteredFieldsNames } from '@gef-ui/redux-common/selectors/registeredFields';
import { composeAction } from '@gef-ui/redux-common/utils';
import { createAction } from '@gef-ui/utils/fsaActions';
import { validateAllFieldsAsync, validateFieldsAll } from '@gef-ui/validations/actions/validate';
import always from "ramda/es/always";
import any from "ramda/es/any";
import both from "ramda/es/both";
import compose from "ramda/es/compose";
import filter from "ramda/es/filter";
import map from "ramda/es/map";
import not from "ramda/es/not";
import o from "ramda/es/o";
import propEq from "ramda/es/propEq";
import flipIncludes from "ramda-extension/es/flipIncludes";
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import noop from "ramda-extension/es/noop";
import toCamelCase from "ramda-extension/es/toCamelCase";
import { formActions, formState } from '../../constants';
import { getFormValidState } from '../../selectors';
export const setAllFieldsDirty = (formName)=>()=>(dispatch, getState)=>compose(dispatch, updateFieldState(formName), map(always({
                pristine: false
            })), getRegisteredFields(formName))(getState());
const changeFieldValue = (path, value, temp = false)=>({
        path,
        value,
        temp
    });
export const updateFieldValue = memoizeWithIdentity((formName)=>createAction(composeAction(formName, formActions.UPDATE_FIELD_VALUE), changeFieldValue));
export const defaultFieldValue = memoizeWithIdentity((formName)=>createAction(composeAction(formName, formActions.DEFAULT_FIELD_VALUE), changeFieldValue));
const anyBEMessage = any(both(propEq(globalErrors.origin.BE, 'origin'), o(not, propEq(globalErrors.severity.WARNING, 'severity'))));
export const validateForm = memoizeWithIdentity((formName)=>()=>async (dispatch, getState)=>{
            const state = getState();
            const globalErrors = getGlobalErrors(formName)(state);
            if (anyBEMessage(globalErrors)) {
                return false;
            }
            const registeredFieldsNames = getRegisteredFieldsNames(formName)(state);
            dispatch(validateFieldsAll(formName)(registeredFieldsNames));
            await dispatch(validateAllFieldsAsync(formName, registeredFieldsNames));
            return getFormValidState(getState(), {
                formName
            }) === formState.VALID;
        });
export const validateFields = memoizeWithIdentity((formName)=>(fieldsToValidate)=>async (dispatch, getState)=>{
            const fieldNames = o(filter(flipIncludes(fieldsToValidate)), getRegisteredFieldsNames(formName))(getState());
            dispatch(validateFieldsAll(formName)(fieldNames));
            await dispatch(validateAllFieldsAsync(formName, fieldNames));
            return getFormValidState(getState(), {
                formName,
                fieldNames
            }) === formState.VALID;
        });
export const formActionsFactory = (formName)=>({
        [toCamelCase(formName)]: {
            incrementStep: createAction(composeAction(formName, formActions.INCREMENT_STEP), noop),
            replaceData: createAction(composeAction(formName, formActions.REPLACE_DATA), (formData)=>formData),
            decrementStep: createAction(composeAction(formName, formActions.DECREMENT_STEP), noop),
            resetForm: createAction(composeAction(formName, formActions.RESET_FORM), noop),
            setStep: createAction(composeAction(formName, formActions.SET_STEP), (step)=>step)
        }
    });
